import { useEffect, useState } from "react";
import SituationCard from "../../components/situation/situation";
import { config } from "../../config";
import GameOverScreen from "../game_over/game_over_screen";
import StartGameScreen from "../startgame/startgame";
import "./game.css";
import axios from "axios";

function Game() {
  const [numRounds, setNumRounds] = useState(0);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [gameEnd, setGameEnd] = useState(false);
  const [currentCard, setCurrentCard] = useState();
  const [startgame, setStartGame] = useState(false);
  const [questionBank, setQuestionBank] = useState([]);
  const [stillPlayingTimeout, setStillPlayingTimeout] = useState();
  // eslint-disable-next-line no-unused-vars
  const [secondsPlayed, setSecondsPlayed] = useState(0);
  const [gameData, setGameData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchGameData();
  }, []);
  useEffect(() => {
    if (numRounds > gameData?.data?.length) {
      setGameEnd(true);
      window.analytics.track("ZG: Cards Gamepage - Game Over", {
        "Coins Earned": correctAnswers * config.coinMultiplier,
      });
      clearInterval(stillPlayingTimeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numRounds]);

  const fetchGameData = async () => {
    setLoading(true);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const { data } = await axios.get(config.URLS.FETCH_GAME, {
      params: {
        username: config.BACKEND_USERNAME,
        api_secret: config.API_KEY,
        game_id: urlParams.get("game_id"),
      },
    });
    console.log(data);
    setGameData(data[0]);
    setQuestionBank(data[0].data);
    setLoading(false);
  };
  const getNewCard = (resetNumrounds) => {
    console.log("Override", resetNumrounds);

    const tempBank = questionBank.length ? [...questionBank] : gameData.data;
    const random = Math.floor(Math.random() * tempBank.length);

    const data = {
      situation: tempBank[random],
      round: resetNumrounds ? 1 : numRounds + 1,
    };
    console.log({
      question: tempBank[random].question,
      questionBank,
      gameData,
    });
    setCurrentCard(data);
    setQuestionBank((q) => {
      return q.filter((t) => t.question !== tempBank[random].question);
    });
    setNumRounds((n) => n + 1);
  };

  const onStartGame = (resetNumrounds) => {
    setCorrectAnswers(0);
    setNumRounds(0);
    setGameEnd(false);
    setQuestionBank(gameData.data);
    getNewCard(resetNumrounds);
    window.analytics.track("ZG: Cards Gamepage - Game Started");

    const timeout = setInterval(() => {
      let seconds = 0;
      setSecondsPlayed((s) => {
        seconds = s;
        return s + 10;
      });
      window.analytics.track("ZG: Cards Gamepage - Still Playing", {
        duration: seconds,
      });
    }, 10000);

    setStillPlayingTimeout(timeout);

    setStartGame(true);
  };

  if (loading) {
    return <div>Loading</div>;
  }

  if (!gameData || !questionBank) {
    return <div>Error loading game data.</div>;
  }

  if (gameEnd) {
    return (
      <GameOverScreen
        points={correctAnswers * config.coinMultiplier}
        restartGame={() => {
          console.log("restarted game");
          onStartGame(true);
        }}
      />
    );
  }

  if (!startgame) {
    return (
      <StartGameScreen
        setStart={() => {
          onStartGame();
          window.analytics.track("ZG: Cards Gamepage - Game Started");
        }}
        rules={gameData.how_to_play}
      />
    );
  }

  return (
    <div className="game-container">
      <SituationCard
        onComplete={(correct) => {
          if (correct) setCorrectAnswers((c) => c + 1);
          getNewCard();
        }}
        data={currentCard}
        gameData={gameData}
      />
    </div>
  );
}

export default Game;
